import { 
	GET_PROJECT_TWR_ESM_CATEGORIES, 
	GET_PROJECT_TWR_ESM_CATEGORY,
	CREATE_PROJECT_TWR_ESM_CATEGORY,
	UPDATE_PROJECT_TWR_ESM_CATEGORY,
	DESTROY_PROJECT_TWR_ESM_CATEGORY,
} from "./actions"

export function ProjectTwrEsmCategoriesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_TWR_ESM_CATEGORIES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_TWR_ESM_CATEGORY}_FULFILLED`:
		case `${CREATE_PROJECT_TWR_ESM_CATEGORY}_FULFILLED`:
		case `${UPDATE_PROJECT_TWR_ESM_CATEGORY}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_TWR_ESM_CATEGORY}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectTwrEsmCategoriesReducer } from "modules/project/twr/esm_categories/reducer"

// project_twr_esm_categories:ProjectTwrEsmCategoriesReducer,
